import { Grid } from "@material-ui/core";
import { Card1, Card2 } from "components/Card";
import { useDevice } from "components/DeviceContext.js";


const Convocacao = () => {
    const { isMobile } = useDevice();
    return (
        <>
            <Grid container
                style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    flexDirection: isMobile ? 'column' : '',
                    maxHeight: isMobile ? '100%' : '100%',
                    fontFamily: 'Open sans',
                    margin: isMobile ? '' : '2em 0 5em'
                }}>
                <Grid item xs={12} md={4} lg={5}
                    style={{
                        textAlign: 'justify',
                        fontSize: isMobile ? '14px' : '16px',
                        padding: isMobile ? '1.5em' : '0',
                    }}>
                    <h1 style={{
                        color: 'var(--azul)',
                        fontSize: '2em'
                    }}>
                        Convocação
                    </h1>
                    <p>
                        É com satisfação que a Confederação Nacional de Municípios (CNM) convoca os (as) gestores (as) municipais a
                        participarem da Campanha nacional <span>“Municípios pela infância e adolescência”.</span>
                    </p>
                    <p>
                    Com objetivo de incentivar a criação, a regularização e o cadastramento dos Fundos Municipais da Infância e Adolescência (FIA),
                    e, assim, fortalecer suas capacidades em captação de recurso para o fortalecimento de ações, programas e projetos nessa área, a
                    CNM dá continuidade a essa tão importante campanha e convida gestores (as), técnicos (as), conselheiros e toda a comunidade a
                    conhecer um pouco mais dessa estratégia para o financiamento de projetos, programas e ações sociais voltadas às crianças e aos adolescentes.
                    </p>
                    <p>
                        Outro objetivo dessas ações é contribuir com o desenvolvimento social de sua comunidade, investindo na proteção e na promoção dos
                        direitos das crianças e dos adolescentes.
                    </p>
                    <p>
                        Os Fias podem receber doações de bens, destinação de imposto de renda pessoa física e jurídica, assim como multas estabelecidas pelo
                        Estatuto da Criança e do Adolescente (ECA).
                    </p>
                    <p>
                        Não fique de fora, seja parceiro do seu Município e participe!
                    </p>
                </Grid>
                <Grid item xs={12} md={5} lg={4}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                    <Card1 />
                    <Card2 />

                </Grid>

            </Grid>
        </>
    )
}


export default Convocacao;
